// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___vILPg","button":"styles-module__button___3TgOr","control":"styles-module__control___1Oem_"};